module.exports = __webpack_public_path__ + "media/wood_1.5b3de827.webm";